import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Preview from "./Preview";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App">
              <header className="App-header"></header>
            </div>
          }
        />
        <Route path="/preview/stage/:inbox_token" element={<Preview />} />
        <Route path="/preview/dev/:inbox_token" element={<Preview />} />
        <Route path="/preview/:inbox_token" element={<Preview />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
